import { createFileRoute, notFound, redirect } from '@tanstack/react-router'
import { isAxiosError } from 'axios'
import * as v from 'valibot'

import keycloak from '@/core/keycloak'
import { tryCatch } from '@/core/utils/tryCatch'
import { company } from '@/http/api/company'

const validateSearch = v.object({
  locale: v.optional(v.string()),
})

export const Route = createFileRoute('/registration/$ssoSourceId')({
  validateSearch,
  beforeLoad: async ({ params: { ssoSourceId }, search }) => {
    if (keycloak.authenticated) {
      throw redirect({ to: '/home' })
    }

    const [error] = await tryCatch(
      company.noEmailUsers.details({ params: { ssoSourceId } }),
    )

    if (error) {
      if (isAxiosError(error) && error.response?.status === 404) {
        throw notFound()
      }
      throw error
    }

    const url = new URL(
      `auth/realms/${keycloak.realm}/no-email-users/registration`,
      keycloak.authServerUrl,
    )
    url.searchParams.set('sso_source_id', ssoSourceId)
    if (search.locale) {
      url.searchParams.set('lang', search.locale)
    }
    throw redirect({ href: url.toString() })
  },
})
